import React, { useState } from 'react';
import { calcPediatricDose } from '../../utils/pediatricDose';

const DRUGS = ['paracetamol', 'ibuprofen', 'amoxicillin', 'azithromycin'];

export default function PediatricDoseCalculator({ onApply }) {
  const [open, setOpen] = useState(false);
  const [weight, setWeight] = useState('');
  const [age, setAge] = useState('');
  const [drug, setDrug] = useState('paracetamol');
  const result = weight ? calcPediatricDose({ drug, weightKg: weight, ageYears: age }) : null;

  if (!open) {
    return (
      <button type="button" className="btn btn-sm btn-secondary" onClick={() => setOpen(true)}>
        Pediatric dose
      </button>
    );
  }

  return (
    <div className="card" style={{ marginTop: 8, background: '#f0fdf4' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>Pediatric dose calculator</strong>
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => setOpen(false)}>×</button>
      </div>
      <div className="form-grid" style={{ marginTop: 8 }}>
        <div className="field"><label>Weight (kg)</label><input className="input" type="number" value={weight} onChange={(e) => setWeight(e.target.value)} /></div>
        <div className="field"><label>Age (years)</label><input className="input" value={age} onChange={(e) => setAge(e.target.value)} /></div>
        <div className="field full">
          <label>Drug</label>
          <select className="input" value={drug} onChange={(e) => setDrug(e.target.value)}>
            {DRUGS.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
      </div>
      {result && !result.error && (
        <div style={{ marginTop: 8 }}>
          <p><strong>{result.drug}</strong> — {result.dose} {result.frequency}</p>
          <p className="hint">{result.note}</p>
          {onApply && <button type="button" className="btn btn-sm btn-primary" onClick={() => onApply(result)}>Add to Rx</button>}
        </div>
      )}
    </div>
  );
}
